"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceStatus = void 0;
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["Canceled"] = "CANCELED";
    InvoiceStatus["MarkedAsPaid"] = "MARKED_AS_PAID";
    InvoiceStatus["Overdue"] = "OVERDUE";
    InvoiceStatus["Paid"] = "PAID";
    InvoiceStatus["Pending"] = "PENDING";
    InvoiceStatus["Sent"] = "SENT";
})(InvoiceStatus = exports.InvoiceStatus || (exports.InvoiceStatus = {}));
